// @flow

import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';

export function validator({
  prsSupport,
  spec,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  if (userInputName === 'selectedEWallet') {
    return onlyWhen('filed_ewallet_select_wallet') && validateEwallet(userInputValue);
  }

  return VALID;
}

function validateEwallet(ewalletCode?: string): ?UserInputValidationError {
  if (!ewalletCode || ewalletCode.trim() === '')
    return { id: 'empty' };

  return VALID;
}
